export default "__VITE_ASSET__Ba$mGh6H__"